import { getParams } from "./utils";
import { generate, highLightExcutor } from "./components/updateProcedure";

// get all highlight context
const allSectionMap = {
  UpdateProcdureFileProcess: generate,
};

// render highlight effect
const postActionMap = {
  UpdateProcdureFileProcess: highLightExcutor,
};

const renderHighlight = async () => {
  const params = getParams();
  if (!params) return;

  if (params.key in allSectionMap) {
    const result = await allSectionMap[params.key as keyof typeof allSectionMap](params.params);
    postActionMap[params.key as keyof typeof postActionMap](result);
  }
};

export default renderHighlight;
